export const MODAL_NAMES = {
  TECH_SPECS: 'TECH_SPECS',
  VERIFIED_REFURBISHED: 'VERIFIED_REFURBISHED',
} as const
